module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/briefing_en-5a81ae8a9e36ae61eba59fb4e7274f5e.gif";